import { useEffect } from "react";
import { Link } from "react-router-dom";

function Blog() {
  useEffect(() => {
    document.title = "leah thinks";
  }, []);

  return (
    <div>
      <Link to="/" style={{ position: 'absolute', top: '1rem', left: '1rem', fontSize: '0.85rem', textDecoration: 'underline', color: '#333333' }}>
        𖦹 back to home
      </Link>
      <p>Thoughts coming soon...</p>
    </div>
  );
}

export default Blog;